import { useCallback } from 'react';
import URI from 'urijs';
import useActiveState from './useActiveState';
import useInviteFriends from '../view/components/useInviteFriends';

export default function usePathResolver() {

  const [config] = useActiveState('config')
  const invitePath = useInviteFriends()

  const getPath = useCallback((obj) => {
    if (obj.name == 'vipCenter' || obj.type == 'vip' || obj.type == 'rechargeVip') {
      return "/save/newvip";
    } else if (obj.name == 'savingsCard' || obj.type == 'card' || obj.type == 'mcard') {
      return "/save/newcard";
    } else if (obj.name == 'trypaly' || obj.type == 'tryPlay') {
      return "/task/tryplay";
    } else if (obj.name == 'inviteFriends' || obj.type == 'share') {
      return invitePath;
    } else if (obj.name == 'honor' || obj.type == 'honor') {
      return '/growthlevel';
    } else if (obj.type == 'freeReceiveVoucher') {
      return '/voucher';
    } else if (obj.type == 'special') {
      if (obj.special_type == '6') {
        return "/party/beta?id=" + obj.value;
      } else {
        return '/game/project?id=' + obj.value;
      }
    } else if (obj.type == 'trade') {
      return '/trade';
    } else if (obj.type == 'openServer') {
      return '/server';
    } else if (obj.type == 'goldMall') {
      return '/shop';
    } else if (obj.type == 'noviceTask') {
      return '/task/novice';
    } else if (obj.type == 'video') {
      return '/index/video';
    } else if (obj.type == 'tradeGoods') {
      return '/trade/good?source=czjl';
    } else if (obj.type == 'webview') {
      let url = URI(obj.value)
        .addQuery('username', localStorage.getItem('username'))
        .addQuery('token', localStorage.getItem('token'))
        .addQuery('location_url', window.location.origin)
        .addQuery('origin', 'react')
        .toString();
      return url;
    } else if (obj.type == 'authoriry_record') {
      return '/user/authority';
    } else if (obj.type == 'vouchandgift') {
      return '/giftproject'
    } else if (obj.type == 'signgift') {
      return '/signgift'
    } else if (obj.type == 'game_detail') {
      return `/game?id=${obj.game_id}`;
    } else if (obj.type == 'game_strategy') {
      return `/article/detail?id=${obj.value}&type=raiders`;
    } else if (obj.type == 'game_activity') {
      return `/article/detail?id=${obj.value}&type=activity`;
    } else if (obj.type == 'cloud_hangup') {
      return `/hangup`;
    }
    return ''; // 默认路径
  }, [config]);

  return { getPath };
}